<template>
  <div class="loader-wrapper">
    <div class="dots-wrapper">
      <div class="dot --left"></div>
      <div class="dot --center"></div>
      <div class="dot --right"></div>
    </div>
    <div class="text-wrapper" v-if="title || subtitle">
      <span v-if="title" class="t3 -t_semi-bold">{{ title }}</span>
      <span v-if="subtitle" class="t3">{{ subtitle }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PulseLoader',
  props: {
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@ui-kit/styles/animations/_pulse.scss";

.loader-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 1rem;

  .dots-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .text-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
  }
}

$dots-size: 16px;
$dots-radius: calc($dots-size / 2);
$dots-spacing: 4px;
$dots-grow-time: 1.8s;

.dot {
  display: inline-block;
  width: $dots-size;
  height: $dots-size;
  border-radius: $dots-radius;
  background-color: $color-negative-500;
  color: $color-negative-500;
  transform: scale(0);
  animation: pulse $dots-grow-time infinite linear;

  &.--left {
    margin-right: $dots-spacing;
    animation-delay: 0s;
  }

  &.--center {
    animation-delay: 0.25s;
  }

  &.--right {
    margin-left: $dots-spacing;
    animation-delay: 0.5s;
  }
}
</style>
